import React, {Component} from "react";

export class Work extends Component {
    render() {
        const slides = Array(50).fill().map((item, i) => {
            let path = `./${i + 1}.jpg`
            const image = <img key={i} onclick="magnify($(this).attr('src'))" src={path}/>
            return image
        });
        return (
            <div id="work">
                <h1>work</h1>
                <div id="photos">
                    {slides}
                </div>
            </div>
        );
    }
}
